import Html2PDF from "html2pdf.js";

export async function downloader(element_id: string): Promise<string> {
  return new Promise((resolve, reject) => {
    try {
      const ele = document.getElementById(element_id);
      //console.debug("downloader ele:", ele, { element_id });
      if (ele) {
        const opts = {
          margin: 0.05,
          filename: "LombardoHomesAndEstates.pdf",
          enableLinks: true,
          html2canvas: {
            scale: 1,
            useCORS: true,
          },
          jsPDF: {
            unit: "in",
            format: "letter",
          },
        };
        Html2PDF().from(ele).set(opts).save().then(() => {
          resolve('ok');
        }).catch((reason: any) => {
          reject(reason);
        });
        return;
      }
      reject('Element not found');
    } catch (err) {
      reject(err);
    }
  });
}
